import { Input } from '@/components/ui/input';
import { ChangeEvent } from 'react';

interface JWInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string
    error?: string
    fullWidth?: boolean
}

const JWInput = ({
    label = '',
    error = '',
    fullWidth = false,
    className = '',
    onChange,
    ...props
}: JWInputProps) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange({
                ...e,
                target: {
                    ...e.target,
                    value: e.target.value
                }
            });
        }
    };

    return (
        <div className={`flex flex-col ${fullWidth ? 'w-full' : ''}`}>
            {label && (
                <label className="text-sm font-medium text-gray-700 mb-1">
                    {label}
                </label>
            )}
            <Input
                className={`rounded-lg border-gray-300 shadow-sm ${className}`}
                onChange={handleChange}
                {...props}
            />
            {error && (
                <span className="text-red-500 text-sm mt-1">{error}</span>
            )}
        </div>
    );
};

export default JWInput;
